/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: FeaturesManager.ts
 * Project: mle-client-n
 * Committed last: 2022/1/11 @ 2342
 * ---
 * Description:
 */

import {Feature} from './Feature';
import {FeatureException} from './FeatureException';

export interface IFeaturesManager {
  functionalities: Feature<any, any, any>[];
}

/**
 * Manages all features of this work-area
 */
export class FeaturesManager<SourceType> implements IFeaturesManager {
  functionalities: Feature<any, any, any>[];
  initData: any;

  constructor(funcs: any[], source: SourceType, initData?: any) {
    // Automatically load all feature instances
    this.functionalities = [];
    for (const cls of funcs) {
      this.functionalities.push(new cls(source));
    }
    this.initData = initData || {};
  }

  /**
   * Get a functionality by its name
   * @param name Functionality name
   */
  getByName<T extends Feature<any, any, any>>(name: string): T {
    return this.functionalities.filter((it) => {
          if (it.featureName === name)
            if (!it.isEnabled()) {
              throw new FeatureException('Tryied to acccess disabled feature', it);
            } else {
              return it;
            }
        }
    )[0] as T;
  }

  /**
   * Add a new functionality to this manager
   * @param feature
   */
  attachFeature<T, D>(feature: Feature<T, D, any>): void {
    this.functionalities.push(feature);
  }

  /**
   * Attach multiple features
   * @param features Features to attach
   */
  attachFeatures(features: Feature<any, any, any>[]): void {
    this.functionalities.push(...features);
  }

  /**
   * Shortcut for iterating (also disabled ones)
   * @param iterator
   */
  forEach(iterator: (ft: Feature<any, any, any>) => void): void {
    this.functionalities.forEach(iterator);
  }

  /**
   * Init all functionalities, only if they are enabled
   */
  initAll() {
    this.forEach((it) => {
      if (it.isEnabled())
        it.init(this.initData);
    });
  }

  /**
   * Destroy all features
   */
  destroyAll() {
    this.forEach(it => {
      it.destroy();
    });
  }
}